import React, {useCallback, useEffect, useRef, useState} from "react";
import Api from "../../Api";
import {withAuth} from "../../hoc/Auth";
import {Wrapper, Container, Column} from "../../hoc/Layout";
import TrafficMonitoringTable from "../../Components/ComponentsOfAdministrator/TrafficMonitoringTable";

var REFRESH_INTERVAL_MS = 30000;

var TrafficMonitoringPage = withAuth(function(_ref) {
    var token = _ref.token;

    var [merchants, setMerchants] = useState([]);
    var [updatedAt, setUpdatedAt] = useState(null);
    var [loading, setLoading] = useState(true);

    var loadingRef = useRef(false);

    var fetchData = useCallback(function(isInitial) {
        if (loadingRef.current) return;
        loadingRef.current = true;
        if (isInitial) setLoading(true);

        new Api({token: token}).getTrafficMonitoring().then(function(data) {
            if (data && data.merchants) {
                setMerchants(data.merchants);
                setUpdatedAt(data.updated_at || null);
            }
        }).catch(function(e) {
            console.error("TrafficMonitoring fetch error", e);
        }).finally(function() {
            loadingRef.current = false;
            if (isInitial) setLoading(false);
        });
    }, [token]);

    useEffect(function() {
        fetchData(true);
        var interval = setInterval(function() { fetchData(false); }, REFRESH_INTERVAL_MS);
        return function() { clearInterval(interval); };
    }, [fetchData]);

    return (
        <Wrapper>
            <Container>
                <Column width="full">
                    <TrafficMonitoringTable
                        merchants={merchants}
                        updatedAt={updatedAt}
                        loading={loading}
                        onRefresh={function() { fetchData(false); }}
                    />
                </Column>
            </Container>
        </Wrapper>
    );
});

export default TrafficMonitoringPage;



// WEBPACK FOOTER //
// ./src/PagesOfAdministrator/TrafficMonitoring/index.js